<template>
  <div>
    <div class="slide-proportion-2-3">
      <div class="left-block-positioner">
        <h1 class="slide-header">ФАКТ 1</h1>
        <p class="tagline">
          Дизель PULLS Diesel Арктика на ОККО не замерзає до -40⁰С
        </p>
        <a
          type="button"
          class="custom-btn"
          @click="$emit('pause', true)"
          @mouseover="$emit('pause', true)"
          @mouseout="$emit('start-next', true)"
          target="_blank"
          href="https://www.okko.ua/fuel-map?filter%5Bgas_stations,fuel_type%5D=256"
        >
          ДЕ ЗАПРАВИТИ?
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped>
  @import '~styles/scss/slide-fragment.scss';
  .left-block-positioner {
    @media screen and (min-width: $av-medium-screen) {
      margin-top: 18%;
    }
  }

  .custom-btn {
    margin-top: 50px;

    @include respond-to(tabletRotate) {
      display: none;
    }
  }

  .tagline {
    @include respond-to(tabletRotate) {
      height: 38px;
      @media screen and (max-height: $mm-h) {
        height: 14px;
      }
      @media screen and (max-height: $r-h) {
        height: 14px;
      }
    }
  }
  @media screen and (max-height: 930px) and (min-width: 1260px) and (max-width: 1920px) and (max-height: 41.1vw) {
    .left-block-positioner {
      margin-top: 60px;
    }
    .custom-btn {
      margin-top: 20px;
    }
  }
  @media screen and (min-height: 676px) and (min-width: 1286px) and (max-height: 760px) and (max-width: 1440px) {
    .left-block-positioner {
      margin-top: 40px;
    }
    .custom-btn {
      margin-top: 20px;
    }
  }
  @media screen and (min-width: 1590px) and (max-width: 1601px) and (max-height: 775px) {
    .left-block-positioner {
      margin-top: 40px;
    }
  } 
</style>



// WEBPACK FOOTER //
// src/components/SlideFragment/Slides/Fact1/Left.vue